// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import VueRouter from 'vue-router';
import router from './router'
// import axios from 'axios'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'

// import EnLocale from 'element-ui/lib/locale/lang/en'
// import ZhLocale from 'element-ui/lib/locale/lang/zh-CN'
// import VueResource from 'vue-resource'
// import 'babel-polyfill'
import 'babel-polyfill'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './assets/js/grobalData'
import * as GlobalConfig from './assets/js/config'
import Lodash from 'lodash'
import VueBus from './vue-bus'
import {writeAppLog} from './assets/js/deviceOperate'
import 'bootstrap/dist/css/bootstrap.min.css'


//解决部分IE浏览器console出错问题
window.console = window.console || (function () {
        let c = {}; c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile
            = c.clear = c.exception = c.trace = c.assert = function () { };
        return c;
    })();


require('!style-loader!css-loader!less-loader!./assets/css/index.less')
    // require('!style-loader!css-loader!less-loader!./assets/theme/blue.less')
    //引入element-ui的动画样式

// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
//     // require('videojs-contrib-hls/dist/videojs-contrib-hls');
//
// import VideoPlayer from 'vue-video-player'
// Vue.use(VideoPlayer);


Vue.config.productionTip = false;
Vue.prototype.GlobalConfig = GlobalConfig;
// Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(Lodash);
Vue.use(VueBus);

//系统错误捕获
const errorHandler = (error, vm)=>{
    // console.error('抛出全局异常');
    // console.error(vm);
    // console.error(error);
    writeAppLog(1,"全局异常："+error);

};
Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = (error)=> errorHandler(error,this);



Vue.filter('imgFilter', function(value) {

    return "http://image.tl-self.com" + value;
    // return '../static/image/demo.jpeg';

});

Vue.filter("textFilter", function(value) {
    if (value.length > 7) {
        return value.slice(0, 7) + "...";
    } else {
        return value;
    }
});

Vue.filter("hideMiddle", function(val) {
    return val.slice(0, 6) + '****' + val.slice(val.length - 4);
});


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
});


// WEBPACK FOOTER //
// ./src/main.js